import http, { createApi } from '@core/fetch'
import { requestHeader } from '@util'
export default {
  // 提现页面替换接口

  // 查询商家钱包
  walletBalance: body =>
    http('/hms/merchantWallet/appApi/wallet/balance', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/merchantWallet/appApi/wallet/balance',
        body
      )
    }),

  // 查询潮婚节商家资金冻结信息
  walletInfo: body =>
    http('/hms/merchantWallet/appApi/wallet/info', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/merchantWallet/appApi/wallet/info',
        body
      )
    }),

  // 查询财务类型(新)
  businessType: body =>
    http('/hms/merchantWallet/appApi/wallet/business/type', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/merchantWallet/appApi/wallet/business/type',
        body
      )
    }),

  // 查询流水列表接口
  getWalletBill: body =>
    http('/hms/merchantWallet/appApi/wallet/bill', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/merchantWallet/appApi/wallet/bill',
        body
      )
    }),

  // 查询流水明细列表
  getWithdrawalCash: body =>
    http('/hms/merchantWallet/appApi/wallet/withdrawal/cash', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/merchantWallet/appApi/wallet/withdrawal/cash',
        body
      )
    }),

  // 查询提现详情
  getCashInfo: body =>
    http('/hms/merchantWallet/appApi/wallet/withdrawal/cash/info', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/merchantWallet/appApi/wallet/withdrawal/cash/info',
        body
      )
    }),

  // 是否可以提现接口判断
  withdrawalCheck: body =>
    http('/hms/merchantWallet/appApi/wallet/withdrawal/check', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/merchantWallet/appApi/wallet/withdrawal/check',
        body
      ),
      onError: null
    }),

  // 提现接口
  withdrawalCash: body =>
    http.post('/hms/merchantWallet/appApi/wallet/apply/withdrawal/cash', {
      body,
      headers: requestHeader(
        'POST',
        '/hms/merchantWallet/appApi/wallet/apply/withdrawal/cash',
        body
      )
    }),
  // 绑卡相关接口

  // 解绑接口
  unbindBankCard: body =>
    http('/hms/settlement/appApi/merchant/unbind/bankCard', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/unbind/bankCard',
        body
      )
    }),

  // 清除原绑定记录
  clearCert: body =>
    http('/hms/settlement/appApi/merchant/clearCert', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/clearCert',
        body
      )
    }),

  // 获取开户行接口
  getBankList: body =>
    http('/hms/settlement/appApi/merchant/queryBankByName', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/queryBankByName',
        body
      )
    }),

  // 根据输入的银行号查银行
  queryBankCradId: body =>
    http('/hms/settlement/appApi/merchant/queryBankByCardId', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/queryBankByCardId',
        body
      )
    }),

  // 查询银行网点
  getBankOutlet: body =>
    http('/hms/settlement/appApi/merchant/bankList', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/bankList',
        body
      )
    }),
  // 提交企业认证信息
  setEnterpriseCert: body =>
    http.post('/hms/settlement/appApi/merchant/enterprise/cert', {
      body,
      headers: requestHeader(
        'POST',
        '/hms/settlement/appApi/merchant/enterprise/cert',
        body
      ),
      onError: null
    }),

  // 提交个人认证信息
  setPersonalCert: body =>
    http.post('/hms/settlement/appApi/merchant/personal/cert', {
      body,
      headers: requestHeader(
        'POST',
        '/hms/settlement/appApi/merchant/personal/cert',
        body
      ),
      onError: null
    }),

  // 获取银联鉴权手机验证码
  phoneSend: body =>
    http('/hms/settlement/appApi/merchant/sendSms', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/sendSms',
        body
      )
    }),

  // 校验银联验证码
  unionPayVerify: body =>
    http('/hms/settlement/appApi/merchant/unionPay/verify', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/unionPay/verify',
        body
      )
    }),

  // 进入绑卡页面前置调用创建子账户接口
  subAccount: body =>
    http('/hms/settlement/appApi/merchant/subAccount', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/subAccount',
        body
      )
    }),

  // 小额鉴权相关接口

  // 小额鉴权重新打款接口
  retryRemit: body =>
    http('/hms/settlement/appApi/merchant/retry/remit', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/retry/remit',
        body
      ),
      onError: null
    }),

  // 小额鉴权校验接口
  microBindCard: body =>
    http('/hms/settlement/appApi/merchant/bankCard/confirm', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/bankCard/confirm',
        body
      ),
      onError: null
    }),

  // 获取企业信息
  getEnterPriceInfo: body =>
    http('/hms/settlement/appApi/merchant/certify', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/certify',
        body
      )
    }),

  // 获取审核数据接口
  getApproveData: body =>
    http('/hms/settlement/appApi/merchant/auditStatus', {
      body,
      headers: requestHeader(
        'GET',
        '/hms/settlement/appApi/merchant/auditStatus',
        body
      )
    }),

  // 获取订单支付状态
  getCashFlowStatus: createApi.get(
    '/p/wedding/admin/APIMerchantOrder/CashFlowStatus'
  )
}
